import { defineMessages, useIntl } from 'react-intl';

import { Button } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsAddAnywayButton = (props: Props) => {
  const { isLoading, disabled, onPress } = props;

  const { formatMessage } = useIntl();

  // ─── Derived ─────────────────────────────────────────────────────────

  const label = formatMessage(messages.addWithoutUnavailable);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Button
      size="large-wide"
      palette="primary"
      isLoading={isLoading}
      disabled={disabled}
      onPress={onPress}
      accessibilityLabel={label}
      accessibilityRole="button"
    >
      {label}
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  addWithoutUnavailable: {
    defaultMessage: 'Add without unavailable',
    description: 'Add To Bag | Unavailable ingredients | Add without unavailable CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isLoading: boolean;
  disabled: boolean;
  onPress: () => void;
};
